import { render, staticRenderFns } from "./contacts-name.vue?vue&type=template&id=508918db&scoped=true&"
import script from "./contacts-name.vue?vue&type=script&lang=js&"
export * from "./contacts-name.vue?vue&type=script&lang=js&"
import style0 from "./contacts-name.vue?vue&type=style&index=0&id=508918db&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508918db",
  null
  
)

export default component.exports